import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  useRecordContext,
  usePermissions,
  SaveButton,
  Toolbar,
} from "react-admin";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ProjectAccessPanel } from "../../components/ProjectAccessPanel";

function EditToolbar() {
  const navigate = useNavigate();
  return (
    <Toolbar sx={{ gap: 1 }}>
      <SaveButton />
      <Button onClick={() => navigate(-1)}>Annulla</Button>
    </Toolbar>
  );
}

function ProjectTitle() {
  const record = useRecordContext();
  return <span>Progetto: {record ? record.name : ""}</span>;
}

export function ProjectEdit() {
  const { permissions } = usePermissions<string>();
  return (
    <Edit title={<ProjectTitle />}>
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput source="id" label="ID" disabled fullWidth />
        <TextInput
          source="name"
          label="Nome progetto"
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="description"
          label="Descrizione"
          multiline
          rows={4}
          fullWidth
        />
        <TextInput
          source="knowledge"
          label="Conoscenza"
          multiline
          rows={4}
          fullWidth
        />
        {permissions === "admin" && <ProjectAccessPanel />}
      </SimpleForm>
    </Edit>
  );
}
